import { schema } from 'normalizr';

const schemaEntity = new schema.Entity('notification');

export default schemaEntity;
